// Constants
import { GA } from '@/app/constants/ga-constants';
// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';

export default {
    name: 'TransactionFailedContainer',
    mixins: [
        GoogleAnalyticsMixins
    ],
    data() {
        return {
            location: null,
            message: null,
        }
    },
    mounted() {
        // Send Analytics
        this.sendEventTrackingToGA(GA.REQUEST_DOG_PURCHASE_FAILED_PAGE.ON_PAGE_LOAD.ACTION, GA.REQUEST_DOG_PURCHASE_FAILED_PAGE.CATEGORY, GA.REQUEST_DOG_PURCHASE_FAILED_PAGE.ON_PAGE_LOAD.LABEL);
        this.updatePaymentStatus();
	},
    methods: {
        updatePaymentStatus(){
            const { message } = this.$route.query;
            this.message = message;
			const {
				location
			} = this.$store.getters.getLatitudePay;
			
            this.location = location;
            this.$store.commit('clearLatitudePay');
        }	
    }
}